import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.primary.main,
  },
}));

const PrivacyLink = () => {
  const classes = useStyles();

  return (
    <Link className={classes.link} to="/privacy" target="_blank">
      Política de Privacidad
    </Link>
  );
};

export default PrivacyLink;
